import React, {memo, useState} from "react";
import {useGroups} from "../../Api/groups";
import ContentBox from "../../../../Components/ContentBox/ContentBox";
import {SimplexionTable} from "../../../simplexion-table/SimplexionTable";
import {baseTableStyles} from "../../../simplexion-table/baseStyle";
import {makeStyles} from "@material-ui/core";
import {makeTableStyles} from "../../../../Components/Table/tableStyles";
import debug from "../../../debug";
import {FilterField} from "../../../../Components/Table/FilterField";
import {updatableCheckBoxStyle} from "../../../simplexion-table/templates/checkbox-input";
import {customActions} from "../../../simplexion-table/templates/action-buttons";
import {inputFieldStyles} from "../../../simplexion-table/templates/text-input";
import LinearProgress from "@material-ui/core/LinearProgress";
import Section from "../../../form/Components/Section/Section";


const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Groups", props]);

    const {path} = props;

    const tableClasses = useTableStyles();

    const urlNs = path[0].url + '/';

    const [state, setState] = useState('');

    const {loadingStatus, data} = useGroups();

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'groups-table',
        nameSpace: 'groups',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'name',
            },
            {
                accessor: 'memberCount',
            },
            {
                accessor: 'description',
            },
            {
                accessor: 'locked',
                renderer: (accessor, record) => record.locked ? `<span><i class="material-icons">lock</i></span>` : `<span><i class="material-icons">lock_open</i></span>`,
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: false,
            },
        ]
    };

    return (
        <ContentBox path={path} add={urlNs + "add"}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;
